import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core'

import { ExtratoDeVendasService } from './shared/extrato-de-vendas.service'
import { FiltroExtrato } from '../shared/filtro-extrato'
import { ExtratoDeVendas } from '../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { Agrupamento } from '../../pkw-data/collect/extrato/agrupamento.model'
import { Venda } from '../../pkw-data/collect/extrato/venda.model'
import { Agrupador } from '../../pkw-data/collect/extrato/agrupador.enum'
import { Estabelecimento } from '../../pkw-data/collect/estabelecimento/estabelecimento.model'
import { Operador } from '../../pkw-data/core/operador.model'
import { OperadorService } from '../../core/services/operador.service'
import { Router } from '@angular/router';

@Component({
    selector: 'col-extratos-de-vendas',
    templateUrl: './extratos-de-vendas.component.html',
    styleUrls: ['../extratos.component.scss']
})
export class ExtratosDeVendasComponent implements OnInit, OnChanges {
    @Input() filtro: FiltroExtrato
   
    @Output() extratoObtido = new EventEmitter<ExtratoDeVendas>()
    
    extrato: ExtratoDeVendas
    agrupamento: Agrupamento<Venda>
    totalVendido: number
    possuiDados: boolean
    extratoCarregado: boolean // TODO: Validar remoção
    carregandoExtrato: boolean
    detalheExpandido: boolean
    radioForm: string
    estabelecimento: string
    operadora: string 
    agrupador: number
    agrupadorOperadora = Agrupador.Operadora.id 
    agrupadorEstabelecimento = Agrupador.Estabelecimento.id  
    
    statusList: Array<any>;

    src: string

    tooltipPlacement: string
    
    operador: Operador
    
    constructor(private extratoDeVendasService: ExtratoDeVendasService, 
                private operadorService: OperadorService,
                private router: Router) { }

    ngOnInit() {
        this.extratoCarregado = true
        this.possuiDados = false
        this.carregandoExtrato = false
        this.detalheExpandido = false
        this.tooltipPlacement = 'top'
        this.operadorService.corrente.subscribe(operador => {
            this.operador = operador
            this.statusList = [
                { situacao: "Sucesso" , class: "fa-check-circle icon-sucesso-color", legenda: "Sucesso", action: () => {} },            
                { situacao: "Inativado ou Operadora fora do ar", class: "fa-exclamation-circle icon-inativo-fora-do-ar-color", legenda: "Inativado / Operadora fora do ar", action: () => {}, classLegenda: "min-width-31" },
                { situacao: "Ação do usuário", class: `fa-exclamation-circle icon-acao-usuario-color ${this.collectPermissaoEditarEstabelecimento()? 'cursor-pointer' : ''}`, legenda: "Bloqueio por múltipla autenticação / Site exigindo ação do usuário / Verificar dados de acesso", action: () => this.navegar('/estabelecimentos'), classLegenda: "min-width-40"   },
                { situacao: "Instabilidade", class: "fa-times-circle icon-instabilidade-color", legenda: "Instabilidade", action: () => {}  },
                { situacao: "Sincronizando" , class: "fa-refresh fa-spin icon-sincronizando-color", legenda: "Sincronizando", action: () => {} }
            ];
        })
       
    }

    ngOnChanges() {
        if (this.filtro) {
            this.agrupador = this.filtro.agrupador
            this.obterExtrato()            
        }       
    }

    obterExtrato() {
        this.carregandoExtrato = true;
        this.possuiDados = false;
        this.extratoDeVendasService
            .pesquisar(this.filtro.toFilter())
            .subscribe(extratos => {
                this.esconderDatelhe()
                this.extrato = extratos[0]
                this.extratoCarregado = true
                this.possuiDados = this.extrato && this.extrato.agrupamentos.length > 0
                this.carregandoExtrato = false
                this.calcularTotalVendido()
                this.extratoObtido.emit(this.extrato)                                     
            })
    }

    exibirDetalhe(agrupamento: Agrupamento<Venda>) {
        if (this.agrupamento === agrupamento) {
            this.detalheExpandido = !this.detalheExpandido
        } else {
            this.agrupamento = agrupamento        
            this.detalheExpandido = true
        }              
    }

    private calcularTotalVendido() {
        if (!this.possuiDados) {
            return null
        }

        this.totalVendido = this.extrato.agrupamentos.reduce((total, agrupamento) => {
            if (agrupamento.operadora.informaLiquido) {
                return total + agrupamento.transacao.valorLiquido
            }

            return total + agrupamento.transacao.valorBruto
        }, 0)
    }

    private esconderDatelhe() {
        this.agrupamento = undefined
        this.detalheExpandido = false
    }

    collectPermissaoEditarEstabelecimento(){
        if(!this.operador) return false;

       return this.operador.UsaCollect().Editar === true;
    }        

    
    adquirirDataInativacao(agrupamento: Agrupamento<Venda>): String{    
        const dataInativacao = agrupamento.estabelecimento.dataInativacao;
        const dataFormatada = dataInativacao.toLocaleString('pt-BR', { 
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).replace(/\//g, '-');
        const mensagemTratada = `Data da Inativação: ${dataFormatada}`;
        return mensagemTratada;
    }

    agenteIsValido(agrupamento: Agrupamento<Venda>): Boolean {
        const isValido = !!agrupamento.estabelecimento && !!agrupamento.estabelecimento.agente && !!agrupamento.estabelecimento.agente.operadoraDeMaquina;
        return isValido;
    }

    adquirirTextoTooltip(agrupamento: Agrupamento<Venda>): String {
        const status = agrupamento.estabelecimento.status;
        let tooltipText;
        
        switch(status) {
            case 'Instabilidade':
                tooltipText = "O estabelecimento está com instabilidade."
                break;
            case 'Inativado ou Operadora fora do ar':
                tooltipText = this.adquirirDataInativacao(agrupamento);
                break;
            case 'Sucesso':
                tooltipText = '';
                break;
            case 'Ação do usuário':
                tooltipText = agrupamento.estabelecimento.situacao;
                break;
            case 'Sincronizando':
                tooltipText = 'O estabelecimento está sincronizando';
                break;
        }

        return tooltipText;
    }

    adquirirIconeStatus(estabelecimento: Estabelecimento): string {
        const status = estabelecimento.status;
        const statusObject = this.statusList.find(statusObj => {
            return statusObj.situacao === status;
        })

        let classIcon = '';

        if (!!statusObject) {
            classIcon = statusObject.class;
        }

        return classIcon;
    }

    executarActionStatus(estabelecimento: Estabelecimento) {
        const status = estabelecimento.status;
        const statusObject = this.statusList.find(statusObj => {
            return statusObj.situacao === status;
        });

        let action = () => {};

        if (!!statusObject) {
            action = statusObject.action;
        }

        action();
    }

    navegar(url: string): void {
        this.router.navigate([url]);
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-vendas/extratos-de-vendas.component.ts